import React from "react";
import { GLOBAL_IMAGES } from "../assets/asset";
import { COMPONENTS_NAV } from "../assets/asset";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const handleNavigation = (urlStr) => {
    navigate(urlStr);
  };

  return (
    <div
      className="flex flex-col w-screen min-h-screen items-center justify-between py-4 px-4"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex w-full items-center justify-between mb-4">
        <img className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24" src={GLOBAL_IMAGES.dingo} alt="Dingo Logo" />
        <img
          className="w-32 h-8 sm:w-36 sm:h-10 md:w-40 md:h-12"
          src={GLOBAL_IMAGES.dingoLogoText}
          alt="Dingo Text Logo"
        />
        <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24"></div>
      </div>
      
      <div className="flex-1 flex flex-col items-center justify-center text-center gap-6 w-full max-w-lg px-4">
        <img
          className="w-full max-w-xs sm:max-w-sm md:max-w-md h-auto object-contain"
          src={COMPONENTS_NAV.nav_main}
          alt="Main Navigation"
        />
        <button
          className="flex items-center justify-center text-white w-full max-w-xs h-12 bg-[#08059B] rounded-md shadow-md hover:bg-[#06047a] transition-colors"
          onClick={() => handleNavigation("/login")}
        >
          Login
        </button>
        {/* <p className="text-black md:font-bold font-mali text-sm">
          Already registered?{" "}
          <span
            className="text-[#08059B] underline cursor-pointer"
            onClick={() => handleNavigation("/login")}
          >
            Log In
          </span>
        </p> */}
        <h1 className="text-black font-mali text-lg sm:text-xl md:text-2xl font-bold max-w-full px-4">
          A world class education for everyone anywhere
        </h1>
      </div>
      
      <div className="h-4"></div>
    </div>
  );
};

export default Navbar;
